import React, { ChangeEvent, useEffect, useState } from 'react'
import Breadcrumbs from '../components/Breadcrumbs/Breadcrumbs'
import FilterContainer from '../components/filter/FilterContainer/FilterContainer'
import CategoryFilter from '../components/filter/options/CategoryFilter'
import PriceFilter from '../components/filter/options/PriceFilter'
import PaginatedList from '../components/PaginatedList/PaginatedList'
import { useAppSelector } from '../redux/hooks'
import { Product } from '../types/types'
import CancelIcon from '@mui/icons-material/Cancel';

import './styles/Products.scss'

interface FilterType {
  name: string
  products: Product[]
}


const Products = () => {
  const pushFilter = (filter: FilterType) => {
    if(!(filters.filter(item => item.name === filter.name).length > 0))
      setFilters([...filters, filter])
  }
  const clearFilters = () => {
    setFilters([])
    setProductsToShow(products)
  }
  const setSort = (sort: string, arr: Product[]) => {
    let products = [...arr]
    switch(sort){
      case 'abc': {
        products.sort((a,b)=> {
          if (a.title < b.title)
            return -1;  
          if (a.title > b.title)
            return 1;
          return 0;
        })
        break
      }
      case 'dsc': {
        products.sort((a,b)=> {
          if (a.title < b.title)
            return 1
          if (a.title > b.title)
            return -1
          return 0
        })
        break
      }
      case 'upprice': {
        products.sort((a,b)=> a.price - b.price)
        break
      }
      case 'lowprice': {
        products.sort((a,b)=> b.price - a.price)
        break
      }
    }
    return products
  }

  const [sorting, setSorting] = useState('')
  const products = useAppSelector((state)=> state.productReducer)
  const [productsToShow, setProductsToShow] = useState<Product[]>([])

  const [filters, setFilters] = useState<FilterType[]>([])
  const modules = [<CategoryFilter key={1} applyAction={pushFilter} products={products}/>, <PriceFilter key={2} applyAction={pushFilter} products={products}/>]
  const [pageSize, setPageSize] = useState(35)

  useEffect(()=> {
    setProductsToShow(products)
  }, [products])

  useEffect(()=>{
    if(filters.length < 1) setProductsToShow(products)
    let arrayToPush: Product[] = products
    filters.forEach((filter: FilterType)=>{
      arrayToPush = arrayToPush.filter(item => filter.products.indexOf(item) !== -1)
    })
    arrayToPush = setSort(sorting, arrayToPush)
    setProductsToShow(arrayToPush)
  }, [filters, setProductsToShow, sorting])

  return (
    <main>
      <Breadcrumbs/>
      <section>
        <div className='products'>
          <div className="container">
            <h1>Products</h1>
            <div className="products-sorting">
              <div className="products-sorting-item">
                <select id='perPage' onChange={(e: ChangeEvent<HTMLSelectElement>)=> setPageSize(parseInt(e.target.value))}>
                  <option value="20">20 per page</option>
                  <option value="35">35 per page</option>
                  <option value="50">50 per page</option>
                </select>
              </div>
              <div className="products-sorting-item">
                <select id='sort' onChange={(e: ChangeEvent<HTMLSelectElement>)=> {
                  setSorting(e.target.value)
                  setProductsToShow(() => setSort(e.target.value, productsToShow))
                }}>
                  <option value="abc">A-Z</option>
                  <option value="dsc">Z-A</option>
                  <option value="upprice">Price up</option>
                  <option value="lowprice">Price low</option>
                </select>
              </div>
            </div>
            <div className="products-wrapper">
              <div className="products-filter">
                <FilterContainer elements={modules}/>
              </div>
              <div className="products-showcase">
                <div className="products-filters">
                  {filters.map(item => {
                    return (<div className='products-filters-item' key={item.name}>
                              <span className='products-filters-item__title'>{item.name}</span>
                              <span className="products-filters-item__delete" onClick={() => {
                                setFilters(filters.filter(filter => filter.name !== item.name))
                              }}>
                                <CancelIcon sx={{width:20, height: 20}}/>
                              </span>
                            </div>)
                  })}
                  {filters.length > 0 ?
                    (<div className='products-filters-item clear' onClick={() => clearFilters()}>
                      <span className="products-filter-item__title">Clear all</span>
                    </div>) : (<div></div>)
                }
                </div>
                <div className="products-list">
                  <PaginatedList products={productsToShow} pageSize={pageSize}/>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  )
}

export default Products